import React from "react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function HubPage(){
  const navigate = useNavigate();
  const { user } = useAuth();
  const isSuperAdmin = user && user.role === 'superadmin';
  
  return (
    <div className="mx-auto max-w-6xl px-4 py-10">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">Welcome, {user?.name}</h1>
        {isSuperAdmin && (
          <Button variant="outline" onClick={()=>navigate("/admin")}>
            Admin
          </Button>
        )}
      </div>
      
      {/* Main Apps Grid - First row 2 items, second row 3 items */}
      <div className="space-y-6">
        {/* Row 1 - Internal Apps */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div 
            className="rounded-lg border p-6 bg-card hover:shadow-lg transition-shadow cursor-pointer flex flex-col justify-center items-center text-center"
            onClick={()=>navigate("/track")}
          >
            <h2 className="text-xl font-semibold mb-2">Timekeeping</h2>
            <p className="text-sm text-muted-foreground mb-4">Track your time.</p>
            <Button className="brand-red-bg text-white">Open Timekeeping</Button>
          </div>
          
          <div 
            className="rounded-lg border p-6 bg-card hover:shadow-lg transition-shadow cursor-pointer flex flex-col justify-center items-center text-center"
            onClick={()=>navigate("/calendar")}
          >
            <h2 className="text-xl font-semibold mb-2">Calendar</h2>
            <p className="text-sm text-muted-foreground mb-4">View and manage case calendar.</p>
            <Button className="brand-red-bg text-white">Open Calendar</Button>
          </div>
        </div>
        
        {/* Row 2 - External Links */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <a
            href="https://sgtlaw.sharepoint.com/_layouts/15/sharepoint.aspx"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-lg border p-6 bg-card hover:shadow-lg transition-shadow flex flex-col justify-center items-center text-center no-underline"
          >
            <h2 className="text-xl font-semibold mb-2 text-foreground">SGT SharePoint Site</h2>
            <p className="text-sm text-muted-foreground mb-2">Access firm documents and resources.</p>
            <p className="text-xs text-muted-foreground italic mb-4">(separate login required)</p>
            <Button className="brand-red-bg text-white" type="button" onClick={(e) => e.stopPropagation()}>
              Open SharePoint
            </Button>
          </a>
          
          <a
            href="https://bdo-us.relativity.one/"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-lg border p-6 bg-card hover:shadow-lg transition-shadow flex flex-col justify-center items-center text-center no-underline"
          >
            <h2 className="text-xl font-semibold mb-2 text-foreground">BDO Relativity</h2>
            <p className="text-sm text-muted-foreground mb-2">Access document review platform.</p>
            <p className="text-xs text-muted-foreground italic mb-4">(separate login required)</p>
            <Button className="brand-red-bg text-white" type="button" onClick={(e) => e.stopPropagation()}>
              Open Relativity
            </Button>
          </a>
          
          <a
            href="https://www.sgtdocketrocket.com"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-lg border p-6 bg-card hover:shadow-lg transition-shadow flex flex-col justify-center items-center text-center no-underline"
          >
            <h2 className="text-xl font-semibold mb-2 text-foreground">Docket Rocket</h2>
            <p className="text-sm text-muted-foreground mb-2">Track Connecticut state court dockets.</p>
            <p className="text-xs text-muted-foreground italic mb-4">(separate login required)</p>
            <Button className="brand-red-bg text-white" type="button" onClick={(e) => e.stopPropagation()}>
              Open Docket Rocket
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
